import React from 'react';

var Audio = function Audio(_ref) {
  var shouldAutoplay = _ref.shouldAutoplay,
      hideControls = _ref.hideControls,
      shouldLoop = _ref.shouldLoop,
      className = _ref.className,
      src = _ref.src,
      children = _ref.children;
  var useSrc = src && !children;
  return React.createElement("audio", {
    autoPlay: shouldAutoplay,
    className: className,
    controls: !hideControls,
    loop: shouldLoop,
    src: useSrc && src
  }, children, React.createElement("p", null, "Sorry, your browser doesn't support the audio element"));
};

Audio.defaultProps = {
  children: null,
  className: null,
  hideControls: false,
  shouldAutoplay: false,
  shouldLoop: false,
  src: null
};
Audio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Audio",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": false,
      "description": "The content of the Audio component. Should be a <source> element or React\r\ncomponent that ultimately resolves in a <source> element"
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "hideControls": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the controls should be hidden"
    },
    "shouldAutoplay": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the audio should play automatically"
    },
    "shouldLoop": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the audio file should be looped"
    },
    "src": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A path to a single source. Is ignored if children are passed in, as well."
    }
  }
};
export default Audio;
export { Audio };